export default __webpack_public_path__ + "static/media/abu-dhabi-global-market.04a91310.png";